/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'CONNECTION_STATE_CHANGED',
]);



// WEBPACK FOOTER //
// ./src/constants/AppConstants.js